import React, { Component } from 'react';

import { observer } from 'mobx-react';
import { Redirect } from 'react-router';
import { Grid, Button } from 'semantic-ui-react';
import { Route } from 'react-router-dom';
import NavigationMenu from '../components/NavigationMenu/NavigationMenu';
import UserManagement from '../components/UserManagement/UserManagement';
import UserProfile from '../pages/UserProfile';
import CompanyBackgroundPage from './CompanyBackgroundPage';
import DifferentiatorsPage from './DifferentiatorsPage';
import TargetProfilePage from './TargetProfilePage';
import TopCompetitorsPage from './TopCompetitorsPage';
import CompanyOfferingsPage from './CompanyOfferingsPage';
import ScheduleAssessmentsPage from './ScheduleAssessmentsPage';
import CompanyAssessmentsPage from './CompanyAssessmentsPage';
import OfferingAssessmentsPage from './OfferingAssessmentsPage';
import NewAssessmentsReportPage from './NewAssessmentsReportPage';
import ValueReportPage from './ValueReportPage';
import AdminPage from './AdminPage';
import EmailAdminPage from './EmailAdminPage';
import HomeLandingPage from './HomeLandingPage';
import GeneralAsksPage from './GeneralAsksPage';
import ModuleArticlePage from './ModuleArticlePage';
import AddressableProblemsPage from './AddressableProblemsPage';
import { CompanyInitializer } from '../CompanyInitializer';
import { withAuth0 } from '@auth0/auth0-react';
import QuestionAnswerPage from './QuestionAnswerPage';
import RecordPresentationPage from './RecordPresentationPage';
import DashboardPage from './DashboardPage';
import TeamDashboardPage from './TeamDashboardPage';
import MyAssessmentsReportPage from './MyAssessmentsReportPage';
import TermsAndConditionsPage from './TermsAndConditionsPage';
import Playbook from '../components/Playbook/Playbook';
import BuildingTheMessage from '../components/Playbook/BuildingTheMessage';
import SalesDeckExplained from '../components/Playbook/BuildingTheMessage/SalesDeckExplained';
import ExampleSalesDeck from '../components/Playbook/BuildingTheMessage/ExampleSalesDeck';
import MessagingExplained from '../components/Playbook/BuildingTheMessage/MessagingExplained';
import AnatomyOfSalesCycle from '../components/Playbook/BuildingTheMessage/AnatomyOfSalesCycle';
import OnboardingTraining from '../components/Playbook/OnboardingTraining';
import TrainingProcessExplained from '../components/Playbook/OnboardingTraining/TrainingProcessExplained';
import ExampleFeedback from '../components/Playbook/OnboardingTraining/ExampleFeedback';
import TrainingSummary from '../components/Playbook/OnboardingTraining/TrainingSummary';
import ExampleSalesMeetings from '../components/Playbook/OnboardingTraining/ExampleSalesMeetings';
import SalesActivity from '../components/Playbook/SalesActivity';
import PlanYourInteractions from '../components/Playbook/SalesActivity/PlanYourInteractions';
import SalesActivityExplained from '../components/Playbook/SalesActivity/SalesActivityExplained';
import Prospecting from '../components/Playbook/SalesActivity/Prospecting';
import IntentionalityCommunication from '../components/Playbook/SalesActivity/IntentionalityCommunication';
import Closing from '../components/Playbook/Closing';
import ProposalProcessExplained from '../components/Playbook/Closing/ProposalProcessExplained';
import ExamplesAndTemplates from '../components/Playbook/Closing/ExamplesAndTemplates';
import ABCCorpSampleProposal from '../components/Playbook/Closing/ABCCorpSampleProposal';
import ABCServicesSampleProposal from '../components/Playbook/Closing/ABCServicesSampleProposal';
import SkillsLeadership from '../components/Playbook/SkillsLeadership';
import CompPlans from '../components/Playbook/SkillsLeadership/CompPlans';
import OrganizationalStructures from '../components/Playbook/SkillsLeadership/OrganizationalStructures';
class Home extends Component {
  constructor() {
    super();
    this.state = {};
  }

  logout = () => {
    const { history } = this.props;

    history.push('/');

    this.props.auth0.logout({
      returnTo: window.location.origin,
    });
  };

  onCompanyChange = async (data) => {
    const { usersStore, companyStore, assessmentsStore, modulesStore, meetingStore } = this.props.rootStore;

    await CompanyInitializer(
      companyStore,
      assessmentsStore,
      usersStore,
      modulesStore,
      data.value
    );
    // Set selectedCompanyId from the loaded company profile to ensure sync
    this.setState({ selectedCompanyId: companyStore.company.id });
  };

  renderComponent(path) {
    const {
      usersStore,
      companyStore,
      assessmentsStore,
      adminStore,
      modulesStore,
      videoPresentationStore, 
      meetingStore
    } = this.props.rootStore;

    const company = companyStore.company;

    const { isAdmin, isSalesMember, isReadOnlyExecutive, isReadOnlySalesManager, isReadOnlySeniorManager } = usersStore.currentUser;

    const showAssessmentActions = !isSalesMember && !isReadOnlyExecutive && !isReadOnlySalesManager && !isReadOnlySeniorManager;
    const showAssessmentReports = !isSalesMember;
    const showUserManagement = !isSalesMember && !isReadOnlyExecutive && !isReadOnlySalesManager && !isReadOnlySeniorManager;
    const showRecordPresentation = !isReadOnlyExecutive && !isReadOnlySalesManager && !isReadOnlySeniorManager;
    const mode = isSalesMember || isReadOnlyExecutive || isReadOnlySalesManager || isReadOnlySeniorManager ? 'readonly' : undefined;
    // Always derive selectedCompanyId from the loaded company profile
    const selectedCompanyId = company?.id;

    return (
      <Grid
        stretched
        style={{ height: '100%' }}
        key={selectedCompanyId}
      >
        <Grid.Column width={3} style={{ marginTop: 40 }}>
          <NavigationMenu path={path} assessmentsStore={assessmentsStore} currentUser={usersStore.currentUser} companyStore={companyStore} adminStore={adminStore} usersStore={usersStore} modulesStore={modulesStore} onCompanyChange={this.onCompanyChange} selectedCompanyId={selectedCompanyId} />
        </Grid.Column>
        <Grid.Column width={13} style={{ margin: 0, paddingTop: 40, paddingBottom: 40 }}>
          <Route path="*">
            <Redirect to="/v1" />
          </Route>

          <Route path='/v1' exact>
            <HomeLandingPage
              usersStore={usersStore}
              assessmentsStore={assessmentsStore}
              companyStore={companyStore}
              meetingStore={meetingStore}
            />
          </Route>
          <Route path='/v1/background'>
            <CompanyBackgroundPage
              companyBackground={companyStore.company.background}
              mode={mode}
            />
          </Route>
          <Route path='/v1/differentiators'>
            <DifferentiatorsPage company={companyStore.company} mode={mode} />
          </Route>
          <Route path='/v1/general-asks'>
            <GeneralAsksPage company={companyStore.company} mode={mode} />
          </Route>
          <Route path='/v1/addressable-problems'>
            <AddressableProblemsPage company={companyStore.company} mode={mode} />
          </Route>
          <Route path='/v1/prospect-profile'>
            <TargetProfilePage company={companyStore.company} mode={mode} />
          </Route>
          <Route path='/v1/top-competitors'>
            <TopCompetitorsPage company={companyStore.company} mode={mode} />
          </Route>
          <Route path='/v1/offerings'>
            <CompanyOfferingsPage company={companyStore.company} mode={mode} />
          </Route>
          <Route path='/v1/questions-answers'>
            <QuestionAnswerPage company={companyStore.company} mode={mode} />
          </Route>
          <Route path='/v1/dashboard'>
            <DashboardPage usersStore={usersStore} companyStore={companyStore} assessmentsStore={assessmentsStore} meetingStore={meetingStore} history={this.props.history} />
          </Route>
          <Route path='/v1/team-dashboard'>
            <TeamDashboardPage usersStore={usersStore} companyStore={companyStore} assessmentsStore={assessmentsStore} />
          </Route>
          {showRecordPresentation && <Route path='/v1/record-presentation'>
            <RecordPresentationPage meetingStore={meetingStore} companyStore={companyStore} videoPresentationStore={videoPresentationStore} assessmentsStore={assessmentsStore} usersStore={usersStore} mode={mode} />
          </Route>
          }
          {showAssessmentActions && (
            <Route path='/v1/schedule-assessments'>
              <ScheduleAssessmentsPage
                usersStore={usersStore}
                assessmentsStore={assessmentsStore}
                company={company}
              />
            </Route>
          )}
          {showAssessmentActions && (
            <Route path='/v1/company-assessments'>
              <CompanyAssessmentsPage
                usersStore={usersStore}
                assessmentsStore={assessmentsStore}
              />
            </Route>
          )}
          {showAssessmentActions && (
            <Route path='/v1/offering-assessments'>
              <OfferingAssessmentsPage
                usersStore={usersStore}
                assessmentsStore={assessmentsStore}
              />
            </Route>
          )}
          <Route path='/v1/assessments-report'>
            <NewAssessmentsReportPage
              usersStore={usersStore}
              assessmentsStore={assessmentsStore}
              companyStore={companyStore}
            />
          </Route>
          <Route path='/v1/my-assessments-report'>
            <MyAssessmentsReportPage
              usersStore={usersStore}
              assessmentsStore={assessmentsStore}
            />
          </Route>
          <Route path='/v1/playbook' exact>
            <Playbook />
          </Route>
          <Route path='/v1/playbook/building-message' exact>
            <BuildingTheMessage />
          </Route>
          <Route path='/v1/playbook/building-message/sales-deck-explained'>
            <SalesDeckExplained />
          </Route>
          <Route path='/v1/playbook/building-message/example-sales-deck'>
            <ExampleSalesDeck />
          </Route>
          <Route path='/v1/playbook/building-message/messaging-explained'>
            <MessagingExplained />
          </Route>
          <Route path='/v1/playbook/building-message/anatomy-sales-cycle'>
            <AnatomyOfSalesCycle />
          </Route>
          <Route path='/v1/playbook/onboarding-training' exact>
            <OnboardingTraining />
          </Route>
          <Route path='/v1/playbook/onboarding-training/training-process-explained'>
            <TrainingProcessExplained />
          </Route>
          <Route path='/v1/playbook/onboarding-training/example-feedback'>
            <ExampleFeedback />
          </Route>
          <Route path='/v1/playbook/onboarding-training/training-summary'>
            <TrainingSummary />
          </Route>
          <Route path='/v1/playbook/onboarding-training/example-sales-meetings'>
            <ExampleSalesMeetings />
          </Route>
          <Route path='/v1/playbook/sales-activity' exact>
            <SalesActivity />
          </Route>
          <Route path='/v1/playbook/sales-activity/plan-your-interactions'>
            <PlanYourInteractions />
          </Route>
          <Route path='/v1/playbook/sales-activity/sales-activity-explained'>
            <SalesActivityExplained />
          </Route>
          <Route path='/v1/playbook/sales-activity/prospecting'>
            <Prospecting />
          </Route>
          <Route path='/v1/playbook/sales-activity/intentionality-communication'>
            <IntentionalityCommunication />
          </Route>
          <Route exact path='/v1/playbook/closing'>
            <Closing />
          </Route>
          <Route path='/v1/playbook/closing/proposal-process-explained'>
            <ProposalProcessExplained />
          </Route>
          <Route path='/v1/playbook/closing/examples-templates'>
            <ExamplesAndTemplates />
          </Route>
          <Route path='/v1/playbook/closing/abc-corp-sample-proposal'>
            <ABCCorpSampleProposal />
          </Route>
          <Route path='/v1/playbook/closing/abc-services-sample-proposal'>
            <ABCServicesSampleProposal />
          </Route>
          <Route exact path='/v1/playbook/skills-leadership'>
            <SkillsLeadership />
          </Route>
          <Route path='/v1/playbook/skills-leadership/comp-plans'>
            <CompPlans />
          </Route>
          <Route path='/v1/playbook/skills-leadership/organizational-structures'>
            <OrganizationalStructures />
          </Route>
          <Route
            path='/v1/value-report/:userId?'
            children={
              <ValueReportPage
                usersStore={usersStore}
                assessmentsStore={assessmentsStore}
              />
            }
          />
          {showUserManagement && (
            <Route path='/v1/users'>
              <UserManagement
                usersStore={usersStore}
                company={companyStore.company}
              />
            </Route>
          )}
          <Route path='/v1/profile'>
            <UserProfile
              currentUser={usersStore.currentUser}
              editUser={usersStore.currentUser}
              companyStore={companyStore}
            />
          </Route>
          <Route path='/v1/terms-conditions'>
            <TermsAndConditionsPage />
          </Route>
          {isAdmin && (
            <Route path='/v1/admin'>
              <AdminPage adminStore={adminStore} />
            </Route>
          )}
          {isAdmin && (
            <Route path='/v1/email-admin'>
              <EmailAdminPage />
            </Route>
          )}
          {
            modulesStore.allArticles.map((article, i) =>
              <Route path={article.path} key={`article_${i}`}>
                <ModuleArticlePage article={article} />
              </Route>
            )
          }
        </Grid.Column>
      </Grid >
    );
  }

  renderInactive() {
    const textStyle = {
      padding: 10,
      color: '#0784a7',
    };

    return (
      <div style={textStyle}>
        Your account is inactive. Please contact your administrator.
        <br />
        <br />
        <Button onClick={this.logout}>Return to Login</Button>
      </div>
    );
  }

  renderDisabled() {
    const textStyle = {
      padding: 10,
      color: '#0784a7',
    };

    return (
      <div style={textStyle}>
        Your account is disabled due to an inactive subscription. Please contact
        your administrator.
        <br />
        <br />
        <Button href='#' onClick={this.logout}>
          Return to Login
        </Button>
      </div>
    );
  }

  render() {
    const { history } = this.props;
    const { usersStore } = this.props.rootStore;
    if (usersStore.currentUser.disabled) {
      return this.renderDisabled();
    } else if (usersStore.currentUser.active) {
      return this.renderComponent(history.location.pathname);
    } else {
      return this.renderInactive();
    }
  }
}

export default withAuth0(observer(Home));
